import ClipPreviewModal from "components/v2/Modals/Clip/ClipPreviewModal";
import { CONTENT_TYPES } from "constants/phase";
import React from "react";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { createStructuredSelector } from "reselect";

const jsonFields = ["previewData"];

const parseQueryData = (queryData) => {
  jsonFields.forEach((field) => {
    if (queryData[field]) {
      try {
        queryData[field] = JSON.parse(queryData[field]);
      } catch (e) {
        console.error(`Failed to parse ${field}`, e);
      }
    }
  });

  return queryData;
};

const PreviewVideo = () => {
  const [searchParams] = useSearchParams();
  const queryData = Object.fromEntries(searchParams);
  const parsedQueryData = parseQueryData(queryData);

  // NOTE: Public route condition is handled based on modalType prop in ClipPreviewModal
  if (parsedQueryData.variantId) {
    return (
      <ClipPreviewModal
        variantData={parsedQueryData}
        modalType="previewVariant"
        {...parsedQueryData}
        contentType={CONTENT_TYPES.VARIANT}
      />
    );
  }

  if (parsedQueryData.clipId) {
    return (
      <ClipPreviewModal clipData={parsedQueryData} modalType="previewClip" downloadDirectly {...parsedQueryData} />
    );
  }

  if (parsedQueryData.clipListId) {
    return (
      <ClipPreviewModal
        clipListData={parsedQueryData}
        modalType="previewClipList"
        downloadDirectly
        {...parsedQueryData}
      />
    );
  }

  if (parsedQueryData.exportedClipId) {
    return (
      <ClipPreviewModal
        clipVideoData={parsedQueryData}
        contentType={CONTENT_TYPES.EXPORTED_CLIP}
        modalType="previewExportedClip"
        downloadDirectly
        {...parsedQueryData}
      />
    );
  }

  return null;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewVideo);
